/**
 * Shared field-change handlers for the VAF create/edit forms.
 *
 * Previously useCreateVehicleAcceptanceForm.js and useUpdateVehicleAcceptanceForm.js
 * each defined their own copies of onInputChange/onNumberChange/onDateChange/
 * onDropdownChange with identical logic (just pointed at a different setState).
 * Both are wired into the same VehicleAcceptanceFormDialog, so they must stay
 * behaviorally identical — this factory is the single place that logic lives now.
 *
 * @param {Function} setFormData - the setState updater for the form being edited
 */
export const createVAFFieldHandlers = (setFormData) => ({
    onInputChange: (e, name) => {
        const val = (e.target && e.target.value) ?? '';
        setFormData((prev) => ({ ...prev, [name]: val }));
    },
    onNumberChange: (e, name) => {
        setFormData((prev) => ({ ...prev, [name]: e.value }));
    },
    onDateChange: (e, name) => {
        setFormData((prev) => ({ ...prev, [name]: e.value }));
    },
    onDropdownChange: (value, name) => {
        setFormData((prev) => ({ ...prev, [name]: value }));
    }
});
